<template>
	<div class="j-main">
		<div data-v-36288b80="" data-v-a5686a06="" class="j-container layout-search router j-container h5"><!---->
			<div data-v-dbeee98c="" data-v-36288b80="" class="hd-search-group">
				<div data-v-dbeee98c="" class="back-icon" @click="goToHome"><i data-v-991cf48f="" data-v-dbeee98c=""
						class="iconfont icon-back"></i></div>
				<form data-v-dbeee98c="" class="search-form van-form" action="javascript: true">
					<div data-v-dbeee98c="" class="input-group van-cell van-field">
						<div class="van-field__left-icon"><i data-v-991cf48f="" data-v-dbeee98c=""
								class="iconfont icon-search"></i></div>
						<div class="van-cell__value van-cell__value--alone van-field__value">
							<div class="van-field__body"><input v-model="inputValue" type="search" placeholder="请输入产品或业务名称关键词"
									class="van-field__control"></div>
						</div>
					</div><button data-v-dbeee98c="" type="submit" @click="goToSearch" class="search-button clickable"> 搜索 </button>
				</form>
			</div>
			<div data-v-36288b80="" class="j-main layout-search-content">
				<div data-v-99074ef9="" data-v-a5686a06="" class="j-container page-search-transfer" data-v-36288b80="">
					<!--<div data-v-99074ef9="" class="page-search-tabs j-header van-tabs van-tabs--line">
						<div class="van-tabs__wrap van-tabs__wrap--scrollable">
							<div role="tablist" class="van-tabs__nav van-tabs__nav--line van-tabs__nav--complete">
								<div role="tab" aria-selected="true" class="van-tab van-tab--active"><span
										class="van-tab__text">招标采购搜索</span></div>
								<div role="tab" class="van-tab"><span class="van-tab__text">企业搜索</span></div>
								<div role="tab" class="van-tab"><span class="van-tab__text">采购单位搜索</span></div>
								<div role="tab" class="van-tab"><span class="van-tab__text">阳光直采</span></div>
								<div role="tab" class="van-tab"><span class="van-tab__text">文档搜索</span></div>
								<div role="tab" class="van-tab"><span class="van-tab__text">供应搜索</span></div>
								<div class="van-tabs__line" style="transform: translateX(52px) translateX(-50%);"></div>
							</div>
						</div>
						<div class="van-tabs__content"></div>
					</div>-->
					<div data-v-c82cb9da="" data-v-99074ef9="" class="page-search-bidding j-main page-search-content">
						<div data-v-c82cb9da="" class="j-container bidding-search-middle-container">
							<!--<div data-v-c82cb9da="" class="j-header">
								<div data-v-c82cb9da="" class="search-type-tab-container"><span data-v-c82cb9da=""
										data-badge="推荐" class="search-type-item clickable j-button-badge"> 超前项目
									</span><span data-v-c82cb9da="" class="search-type-item clickable"> 招标预告
									</span><span data-v-c82cb9da="" class="search-type-item clickable"> 招标公告
									</span><span data-v-c82cb9da="" class="search-type-item clickable"> 招标结果 </span>
								</div>
							</div>-->
							<div data-v-c82cb9da="" class="j-main bidding-search-middle-main">
								<div data-v-c82cb9da="" class="bidding-search-middle-main-content">
								<!--	<div data-v-b571b78b="" data-v-c82cb9da="" class="history-list content-module">
										<div data-v-b571b78b="" class="title-group"><span data-v-b571b78b=""
												class="title">历史搜索</span>
											<div data-v-b571b78b="" class="delete-icon"><i data-v-991cf48f=""
													data-v-b571b78b="" class="iconfont icon-dataDelete"></i></div>
										</div>
										<ul data-v-b571b78b="" class="tag-item">
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break"> 智能化 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break"> 鞋 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break"> 信息化 </div>
											</li>
										</ul>
									</div>-->
									<div data-v-b571b78b="" data-v-c67ac3e0="" data-v-c82cb9da="" class="history-list hot-key-card-container content-module">
										<div data-v-b571b78b="" class="title-group" style=""><span data-v-b571b78b=""
												class="title">热门搜索</span>
											<!--<div data-v-c67ac3e0="" data-v-b571b78b="" class="right-text"><span
													data-v-c67ac3e0="" data-v-b571b78b=""
													class="j-icon j-base-icon icon-update-grey clickable"></span></div>-->
										</div>
										<ul data-v-b571b78b="" class="tag-item">
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break" @click="goToSearch2('信息化')"> 信息化 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break" @click="goToSearch2('软件')"> 软件 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break" @click="goToSearch2('网络')"> 网络 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break" @click="goToSearch2('网络安全')"> 网络安全 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break" @click="goToSearch2('监控')"> 监控 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break" @click="goToSearch2('安防')"> 安防 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break" @click="goToSearch2('服务器')"> 服务器 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break" @click="goToSearch2('弱电')"> 弱电 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break" @click="goToSearch2('系统集成')"> 系统集成 </div>
											</li>
											<li data-v-b571b78b="" class="hover-css--slide">
												<div data-v-b571b78b="" class="content-text word-break" @click="goToSearch2('智能化')"> 智能化 </div>
											</li>
										</ul>
									</div><!---->
								</div>
							</div><!---->
						</div>
						<div data-v-c82cb9da="" class="check-user-dialog">
							<div class="check-power-and-switch"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
	import { useRouter } from 'vue-router'; 
	import { ref } from 'vue';
	export default {
		name: 'SearchMiddle',
		props: {
			msg: String
		},
		setup() {
			const router = useRouter();  // 获取 Vue Router 实例
			
			const inputValue = ref('');
			
			const goToHome = () => {
				router.push('/');
			};
			
			const goToSearch = () => {
				router.push({path: '/SearchPage',query: { keyword: inputValue.value }});
			};
			const goToSearch2 = (keyword) => {
				router.push({path: '/SearchPage',query: { keyword: keyword }});
			};
			return {
				goToHome,
				goToSearch,
				goToSearch2,
				inputValue
			};
		}
	}
</script>

<style scoped>
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/layout-b8970476.css');  /* 引入远程 CSS 文件 */
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-65ed017b.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/BidUpdate-4c4e3a53.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/Ad-2a1ab4c4.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/PopupLayout-734c9dd2.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-468d7f12.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-7bc74ed3.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/popupDataexport-9a587008.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-6ff30bfa.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-0799990e.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/filterHistoryDialog-ffba5828.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-b6da2027.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-b6da2027.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-8ecf630b.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-1ab2b926.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/ScrollNav-6f417c1c.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-e2ab76db.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-ff712df7.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-65ed017b.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-92e55716.css');
</style>